import React, { useState, useEffect } from 'react';
import ChargingGrid from './chargingGrid';
import BuildingGrid from './powerGrid';
import WeatherGrid from './weatherGrid';
import DashboardGrid from './dashboardGrid';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const ROTATION_INTERVAL = 30000; // 30 seconds per grid

const RotatingGrids: React.FC = () => {
  const [currentGridIndex, setCurrentGridIndex] = useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const grids = [
    {
      component: <DashboardGrid />,
      name: 'Summary'
    },
    {
      component: <ChargingGrid />,
      name: 'Charging Status'
    },
    {
      component: <BuildingGrid />,
      name: 'Power Status'
    },
    {
      component: <WeatherGrid />,
      name: 'Weather'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGridIndex((prevIndex) => (prevIndex + 1) % grids.length);
    }, ROTATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box 
      sx={{ 
        position: 'relative',
        height: '100vh',
        width: '100%',
        overflowY: isSmallScreen ? 'auto' : 'visible',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '4px',
          '&:hover': {
            background: '#555',
          },
        },
      }}
    >
      <Box sx={{ minHeight: '100%', width: '100%', position: 'relative' }}>
        <Box sx={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          zIndex: 1000
        }}>
          <img 
            src="/logos/ODP_Logo.png" 
            alt="ODP Logo" 
            style={{
              height: '60px',
              width: 'auto'
            }}
          />
        </Box>
        <Box sx={{
          position: 'absolute',
          top: '85px',
          right: '20px',
          background: 'yellow',
          color: 'black',
          padding: '5px 10px',
          borderRadius: '4px',
          zIndex: 1000
        }}>
          {grids[currentGridIndex].name}
        </Box>
        {grids[currentGridIndex].component}
      </Box>
    </Box>
  );
};

export default RotatingGrids; 